@if (basdata && searchFilter) {
  <rask-arbetsorder-search-filter [title]="texts.filters.virkeskop" (toggleVisibility)="toggleShow()" [visible]="isVisible" [hasValues]="isDirty()" aid="filterVirkeskop">
    <rask-input #kontraktsnummerControl aid="filterVirkeskopKontraktsnummer" [label]="texts.kontraktsnummer" [(ngModel)]="searchFilter.virkeskop.kontraktsnummer" [ngModelOptions]="{standalone: true}"></rask-input>
    <rask-multi-selector
      aid="filterVirkeskopVirkeskopare"
      class="col-3"
      label="{{'LEVERANTOR_LABEL_ANSV_VIRKESKOPARE' | translate}}"
      bindLabel="namn"
      typeToSearchText="{{ 'LEVERANTOR_DETAIL_TYPE_AHEAD_HELP_TEXT' | translate }}"
      loadingText="Laddar..."
      notFoundText="Ingen träff"
      [minTermLength]="3"
      [typeaheadFn]="getAnvandareTypeAhead"
      [selected]="$safeNavigationMigration(searchFilter.virkeskop?.virkeskopare)"
      (change)="onChangeAnsvarigVirkeskopare($event)">
    </rask-multi-selector>
    <rask-input #prislistaControl [label]="texts.prislista" aid="filterVirkeskopPrislista" [(ngModel)]="searchFilter.virkeskop.prislista" [ngModelOptions]="{standalone: true}"></rask-input>
  </rask-arbetsorder-search-filter>
}
